(function (Drupal) {
  Drupal.behaviors.faq = {
    attach: function (context, settings) {
      const faqQuestions = document.querySelectorAll('.faq__question');

      for (const question of faqQuestions) {
        if (!question.classList.contains('js-listener-added')) {
          question.addEventListener('click', function () {
            question.classList.toggle('js-active');
          });
          question.addEventListener('keypress', function (e) {
            e.preventDefault();
            let charCode = e.keyCode || e.which;
            if (charCode === 32) {
              question.classList.toggle('js-active');
            }
          });
          question.classList.add('js-listener-added');
        }
      }

      // Version 1.x
    }
  };
})(window.Drupal);
